import React, { Component } from 'react';

import Rcslider from 'rc-slider';

if (typeof window != 'undefined') {
  require('rc-slider/assets/index.css');
}

export default class ClipControls extends Component {
  onChange(value) {
    this.refs.thumbOffset.value = this.secondsToString(value);
    this.props.onChange(value);
  }

  parseTime(time) {
    var seconds = 0;
    var sections = time.split(':');
    for (var i = 0; i < sections.length; i++) {
      var multiplier = Math.pow(60, i);
      var value = sections[sections.length - 1 - i];
      if (value === '') {
        value = '0';
      }
      seconds += parseFloat(value) * multiplier;
    }
    return seconds;
  }

  secondsToString(seconds) {
    var numhours = Math.floor(seconds / 3600);
    seconds -= numhours * 3600;
    var numminutes = Math.floor(seconds / 60);
    var numseconds = Math.floor((seconds - numminutes * 60) * 10) / 10;
    if (numseconds < 10) {
      numseconds = '0' + numseconds;
    }
    if (numhours === 0) {
      if (numminutes > 0) {
        return numminutes + ':' + numseconds;
      } else {
        return '0:' + numseconds;
      }
    } else {
      var str = numminutes + ':' + numseconds;
      if (numminutes < 10) {
        str = '0' + str;
      }
      return numhours + ':' + str;
    }
  }

  render() {
    var self = this;
    return (
      <div>
        <div id="clip-controls-slider">
          <Rcslider
            max={self.props.duration}
            className="clip-slider-control"
            tipFormatter={null}
            value={self.props.thumbOffset}
            step={0.01}
            onChange={self.onChange.bind(self)}
          />
        </div>
        <div id="clip-controls-time">
          <div className="clip-controls-time-control">
            <input
              className="clip-controls-time-control-text form-control"
              type="text"
              defaultValue={this.secondsToString(this.props.thumbOffset)}
              onChange={(e) => {
                this.props.onChange(this.parseTime(e.target.value));
              }}
              onBlur={(e) => {
                this.props.onChange(this.parseTime(e.target.value), true);
              }}
              ref="thumbOffset"
            />
          </div>
        </div>
      </div>
    );
  }
}
